import PublicHomePage from "@/views/HomePage/PublicHomePage";
import LoginPage from "@/views/Auth/LoginPage";
import Registration from "@/views/Auth/RegistrationPage";
import PasswordResetRequestPage from "@/views/Auth/PasswordResetRequestPage";
import PasswordResetPage from "@/views/Auth/PasswordResetPage";
import InfoPage from "@/views/InfoPage/InfoPage";
import DataSourcesPage from "@/views/InfoPage/DataSourcesPage";
import SafetyAdvicePage from "@/views/InfoPage/SafetyAdvicePage"
import MobileAppPage from "@/views/InfoPage/MobileAppPage";
import RegistrationConfirmPage from "@/views/Auth/RegistrationConfirmPage";
import PublicIzletiPage from "@/views/PublicIzleti/PublicIzletiPage";
import PublicIzletDetailPage from "@/views/PublicIzleti/PublicIzletDetailPage";

// Types
import { RouteType } from "@/@types/common";

const publicRoutes: RouteType[] = [
  { path: "/", name: "Home", component: PublicHomePage },
  { path: "/share", name: "Home", component: PublicHomePage },
  { path: "/web-share", name: "Home", component: PublicHomePage },
  { path: "/login", name: "Login", component: LoginPage },
  { path: "/register", name: "Register", component: Registration },
  {
    path: "/register-confirm",
    name: "Confirm Registration",
    component: RegistrationConfirmPage,
  },
  { path: "/info", name: "Info", component: InfoPage },
  { path: "/izvori-podataka", name: "Data Sources", component: DataSourcesPage },
  { path: "/sigurnosni-savjeti", name: "Safety Advice", component: SafetyAdvicePage },
  { path: "/mobilna-aplikacija", name: "Mobile App", component: MobileAppPage },
  {
    path: "/password-reset-request",
    name: "Password Reset Request",
    component: PasswordResetRequestPage,
  },
  {
    path: "/password-reset",
    name: "Reset Password",
    component: PasswordResetPage,
  },
  {
    path: "/sigurni-izleti",
    name: "Sigurni izleti",
    component: PublicIzletiPage
  },
  {
    path: "/izleti/:id",
    name: "Izlet detail",
    component: PublicIzletDetailPage
  }
];

export default publicRoutes;
